import { useQuery } from '@tanstack/react-query';
import { partnerApi, type ApiResponse } from '@/lib/api';
import { API_ENDPOINTS } from '@/lib/constants';
import type { StripoToken } from './stripo.types';

const stripoKeys = {
  all: ['stripo'] as const,
  token: () => [...stripoKeys.all, 'token'] as const,
};

const getStripoToken = async (): Promise<StripoToken> => {
  const response = await partnerApi.request<ApiResponse<StripoToken>>(
    API_ENDPOINTS.PARTNER.GET_STRIPO_TOKEN,
  );
  return response.data;
};

export const useStripoToken = () => {
  return useQuery({
    queryKey: stripoKeys.token(),
    queryFn: getStripoToken,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  });
};
